import {KeyTag} from "../../api/Model";
import {ChipProps, Tooltip} from "@mui/material";
import React from "react";
import {ColorChip} from "../color-chip/ColorChip";

export function KeyTagChip({keyTag, ...props}: { keyTag: KeyTag } & ChipProps) {
    return (
        <Tooltip title={keyTag.description}>
            <ColorChip {...props} color={keyTag.color} label={keyTag.name} onClick={undefined}/>
        </Tooltip>
    );
}